/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _join = _interopRequireDefault(require("../../../../common/join"));
var getClassNames = function getClassNames(props) {
  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    checked = _ref.checked;
  var rtl = props.rtl,
    inlineBlock = props.inlineBlock,
    readOnly = props.readOnly,
    readOnlyClassName = props.readOnlyClassName,
    theme = props.theme,
    disabled = props.disabled,
    disabledClassName = props.disabledClassName,
    focusedClassName = props.focusedClassName,
    className = props.className,
    childrenPosition = props.childrenPosition;
  var focused = state.focused;
  return (0, _join.default)(props.rootClassName, className, childrenPosition && "".concat(props.rootClassName, "--children-position-").concat(childrenPosition), rtl ? "".concat(props.rootClassName, "--rtl") : "".concat(props.rootClassName, "--ltr"), readOnly && (0, _join.default)("".concat(props.rootClassName, "--read-only"), readOnlyClassName), focused && (0, _join.default)("".concat(props.rootClassName, "--focused"), focusedClassName), disabled && (0, _join.default)("".concat(props.rootClassName, "--disabled"), disabledClassName), inlineBlock && "".concat(props.rootClassName, "--inline-block"), checked === true ? "".concat(props.rootClassName, "--checked") : checked === false ? "".concat(props.rootClassName, "--unchecked") : "".concat(props.rootClassName, "--indeterminate"), theme && "".concat(props.rootClassName, "--theme-").concat(theme));
};
var _default = getClassNames;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/packages/CheckBox/src/utils/getClassNames.js
// module id = 644
// module chunks = 0